import { useState } from 'react'

import { formValidationSchemaNoChanged } from '../../components/Form'
import { EMPTY_OBJECT } from '../../constants/common'
import { collectYupErrors } from '../../utils/validation'

export function useYupValidationWithoutFormik({
  getValidationSchema = formValidationSchemaNoChanged,
  validateData,
  validationSchemaProps,
} = EMPTY_OBJECT) {
  const [validationErrors, setValidationErrors] = useState(EMPTY_OBJECT)

  function isValidForm({ innerValidationSchemaProps } = EMPTY_OBJECT) {
    try {
      getValidationSchema({
        ...validationSchemaProps,
        ...innerValidationSchemaProps,
      }).validateSync(validateData, {
        abortEarly: false,
      })

      setValidationErrors(EMPTY_OBJECT)

      return true
    } catch (err) {
      setValidationErrors(collectYupErrors(err))

      return false
    }
  }

  return {
    isValidForm,
    setValidationErrors,
    validationErrors,
  }
}
